import {
  MelcoModelsUserProductListItem,
  ProductsApi,
  useProductsAPI,
} from "melco-shared-logic";

export type ProductsData = {
  products: MelcoModelsUserProductListItem[];
};

const initialValue = { products: [] };

const handleRequest = async (api: ProductsApi) => {
  const response = await api.productsGetList({
    sortBy: "name.asc",
  });

  const products = response.list ?? [];

  return {
    products,
  };
};

export const useAllProducts = () => {
  return useProductsAPI<ProductsData>({
    initialValue,
    handleRequest,
  });
};
